/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TenantSettingskeyTenantSetting from './TenantSettingskeyTenantSetting';

/**
 * The TenantSettingsKeyBody model module.
 * @module model/TenantSettingsKeyBody
 * @version v0.3
 */
export default class TenantSettingsKeyBody {
  /**
   * Constructs a new <code>TenantSettingsKeyBody</code>.
   * @alias module:model/TenantSettingsKeyBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TenantSettingsKeyBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TenantSettingsKeyBody} obj Optional instance to populate.
   * @return {module:model/TenantSettingsKeyBody} The populated <code>TenantSettingsKeyBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TenantSettingsKeyBody();
      if (data.hasOwnProperty('tenant_setting'))
        obj.tenantSetting = TenantSettingskeyTenantSetting.constructFromObject(data['tenant_setting']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TenantSettingskeyTenantSetting} tenantSetting
 */
TenantSettingsKeyBody.prototype.tenantSetting = undefined;

